import { render, staticRenderFns } from "./SubKategori.vue?vue&type=template&id=054c50ae&scoped=true"
import script from "./SubKategori.vue?vue&type=script&lang=js"
export * from "./SubKategori.vue?vue&type=script&lang=js"
import style0 from "./SubKategori.vue?vue&type=style&index=0&id=054c50ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054c50ae",
  null
  
)

export default component.exports